// utils/menuCache.js
const MEMORY = new Map(); // fastest cache (per tab)
const INFLIGHT = new Map(); // dedupe requests
const TTL_MS = 1000 * 60 * 30; // 30 minutes

const makeKey = (type, lang) => `menu:${type}:${lang}`;

const readSession = (key) => {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const { ts, data } = JSON.parse(raw);
    if (!ts) return null;
    if (Date.now() - ts > TTL_MS) return null;
    return data ?? null;
  } catch {
    return null;
  }
};

const writeSession = (key, data) => {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data }));
  } catch {
    // ignore quota errors
  }
};

export async function getMenuCached(type, lang, fetcher) {
  const key = makeKey(type, lang);

  // 1) memory
  if (MEMORY.has(key)) return MEMORY.get(key);

  // 2) sessionStorage
  const session = readSession(key);
  if (session) {
    MEMORY.set(key, session);
    return session;
  }

  // 3) dedupe inflight
  if (INFLIGHT.has(key)) return INFLIGHT.get(key);

  const promise = (async () => {
    const { data } = await fetcher(lang);
    MEMORY.set(key, data);
    writeSession(key, data);
    return data;
  })().finally(() => {
    INFLIGHT.delete(key);
  });

  INFLIGHT.set(key, promise);
  return promise;
}
